// extracted by mini-css-extract-plugin
export default {"card":"Register_card__34TKh","alert_warning":"Register_alert_warning__bxhn4","loader":"Register_loader__PKwhW"};